import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { type CustomerAttributeListPage_MoveCustomerAttributeToGroupMutation } from '~/gql/graphql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation CustomerAttributeListPage_MoveCustomerAttributeToGroup(
    $id: ID!
    $targetCustomerAttributeGroupId: ID!
  ) {
    moveCustomerAttributeToGroup(
      id: $id
      targetCustomerAttributeGroupId: $targetCustomerAttributeGroupId
    ) {
      customerAttribute {
        id
      }
      errorMessages {
        customerAttributeId
        message
      }
    }
  }
`)

type Variables = {
  customerAttributeId: string
  customerAttributeGroupId: string
}

export const useMoveCustomerAttributeToGroupMutation = (
  options: Omit<
    UseMutationOptions<
      CustomerAttributeListPage_MoveCustomerAttributeToGroupMutation,
      unknown,
      Variables,
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: async (variables: Variables) =>
      graphQLRequest({
        document,
        variables: {
          id: variables.customerAttributeId,
          targetCustomerAttributeGroupId: variables.customerAttributeGroupId,
        },
      }),
    ...options,
  })
}
